import { DueDateStatus, Renewal } from "../interfaces/renewal_types";

// TODO: make this better
export function extractDueDateStatus(renewal: Pick<Renewal, 'feeDueDate' | 'instructionDueDate'>, today: string): DueDateStatus {
    if (today < renewal.instructionDueDate) {
        return 'open'
    } else if (renewal.instructionDueDate === today) {
        return 'critical'
    } else if (today < renewal.feeDueDate) {
        return 'manual-instruction'
    } else {
        return 'too-late'
    }
}

// Maybe we can just use renewal.state ?
export function canBeInstructed({status, renewal, strict = false}: {status: DueDateStatus, renewal?: Renewal, strict?: boolean}) {
    if (strict) {
        return renewal !== undefined && (status === 'critical' || status === 'open' || status === 'early') && (renewal?.instruction === undefined)
    } else {
        return !(renewal === undefined || status === 'too-late' || renewal?.id === undefined) 
    }
}